import BlogSource from "@/api/BlogSource.js";

export const newsModule = {
    state: () => ({
        isLoader: true,
        isLoaderItem: true,
        newsList: [],
        newsItem: null,
    }),
    mutations: {
        setNewsItem(state, data) {
            state.newsItem = [...data];
        },
    },
    getters: {},
    actions: {
        async list({state}, cache = null) {
            state.isLoader = true;
            await this.$API.manager.getSource(BlogSource).getList({
                category_id: 2
            }).then((response) => {
                state.newsList = response;
            }).catch(() => {
                state.newsList = [];
            }).finally(() => {
                state.isLoader = false;
            })
        },
        async getArticle({state, commit}, identifier) {
            state.isLoaderItem = true;
            let query = {};
            if (/^\d+$/.test(identifier)) {
                query = {id: identifier}
            } else {
                query = {slug: identifier}
            }
            console.log(query);
            await this.$API.manager.getSource(BlogSource).getArticle(query).then((response) => {
                state.newsItem = response;
                console.log(response);
                commit('setMetaTitle', response.meta_title, {root: true})
                commit('setMetaRobots', 'index', {root: true})
                commit('setMetaDescription', response.meta_description, {root: true})
            }).catch(() => {
                state.newsItem = null;
            }).finally(() => {
                state.isLoaderItem = false;
            })
        },
    },
    namespaced: true
}
